export default "__VITE_ASSET__BgIWUUw$__"